// extracted by mini-css-extract-plugin
export default {"wrapper":"wMCw1","button":"X8VBn"};